import React from 'react'
import { Button, Col, Row, Typography } from 'antd'
import { PlusOutlined } from '@ant-design/icons'

type Props = {
    title: string;
    buttonText?: string;
    icon?: React.ReactElement
    onClickButton?: () => void;
    // Слот для статусных меток рядом с заголовком. Необязательный: у 20
    // страниц, которые используют компонент, поведение не меняется.
    extra?: React.ReactNode;
}

const AdminPageTitle: React.FC<Props> = ({ title, buttonText, onClickButton, icon, extra }) => (
    <Row justify="space-between" align="middle" style={{ padding: '0 0 15px 0' }}>
        <Col>
            <Row align="middle" gutter={12}>
                <Col>
                    <Typography.Title level={3} style={{ margin: 0 }}>{title}</Typography.Title>
                </Col>
                {extra && <Col>{extra}</Col>}
            </Row>
        </Col>
        {buttonText && onClickButton && (
            <Col>
                <Button type="primary" onClick={onClickButton} icon={icon || <PlusOutlined/>}>{buttonText}</Button>
            </Col>
        )}
    </Row>
)

export default AdminPageTitle
